export default __webpack_public_path__ + "static/media/xport.5c45b3d0.png";